import useIsActive from '../../../hooks/useIsActive'
import ThumbnailLead from '../../articleList/thumbnailLead.component'
import ThumbnailTitle from '../../articleList/thumbnailTitle.component'
import ImageItem from '../../article/imageItem.component'
import { IArticleHead } from '../../../interfaces/article'
import { urlObjectFactoryForPagesWithSlug } from '../../../utils/webmenus'
import { useAppContext } from '../../../context/siteMapContext'
import Link from 'next/link'

interface IFeaturedNewsProps {
  articleHead: IArticleHead
  activeItemId: string
}

const FeaturedNewsThumbnail: React.FC<IFeaturedNewsProps> = ({
  articleHead,
  activeItemId,
}) => {
  const { title, coverImage, lead, slug } = articleHead
  const { webmenus } = useAppContext()
  const webmenu = webmenus[articleHead.heading]
  const isActive = useIsActive(slug, activeItemId)
  const { urlObject, asPath } = urlObjectFactoryForPagesWithSlug(
    '/article',
    articleHead,
    webmenu
  )

  return (
    <Link href={urlObject} as={asPath} shallow>
      <a>
        <div
          className='flex flex-col transition-all ease-in-out delay-150 h-full'
          style={{
            visibility: isActive ? 'visible' : 'hidden',
            display: isActive ? 'block' : 'none',
          }}
        >
          <div className='border-l-2 border-top-news-title-divider pl-[16px] mb-8 xl:mb-12'>
            <ThumbnailTitle title={title} />
          </div>
          {!!coverImage && (
            <div className='pb-8 xl:pb-12 h-[calc((100vw)/16*9)] xl:h-[337px] '>
              <ImageItem url={coverImage.fileThumbUrl} title={coverImage.title} />
            </div>
          )}
          <div className='w-full text-featured-news xl:text-featured-news-xl pb-[12px]'>
            <ThumbnailLead lead={lead} />
          </div>
        </div>
      </a>
    </Link>
  )
}

export default FeaturedNewsThumbnail
